import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '@meplis/environments';

@Injectable({ providedIn: 'root' })
export class GoogleMapsLoaderService {
  private _loaded = false;
  private _loading: Promise<void> | null = null;

  private readonly _isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  public load(): Promise<void> {
    if (!this._isBrowser) return Promise.resolve();

    if (this._loaded || (window as any).google?.maps) {
      this._loaded = true;
      return Promise.resolve();
    }

    if (this._loading) return this._loading;

    this._loading = new Promise<void>((resolve, reject) => {
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.google.mapsKey}&libraries=places`;
      script.defer = true;
      script.onload = () => {
        this._loaded = true;
        resolve();
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });

    return this._loading;
  }
}
